import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.XeroCreateContactPopup.PhoneEditor', {
    countryCodePlaceholder: 'Country',
    areaCodePlaceholder: 'Area',
    phoneNumberPlaceholder: 'Number',
});
